import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["onChange", "disabled", "placeholder", "defaultValue", "style"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import _noop from 'lodash/noop';
var TextInput = /*#__PURE__*/function (_React$Component) {
  _inherits(TextInput, _React$Component);
  var _super = _createSuper(TextInput);
  function TextInput() {
    _classCallCheck(this, TextInput);
    return _super.apply(this, arguments);
  }
  _createClass(TextInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onChange = _this$props.onChange,
        disabled = _this$props.disabled,
        placeholder = _this$props.placeholder,
        defaultValue = _this$props.defaultValue,
        style = _this$props.style,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(Input, _extends({
        style: style,
        defaultValue: defaultValue,
        placeholder: placeholder,
        onChange: onChange,
        disabled: disabled
      }, rest));
    }
  }]);
  return TextInput;
}(React.Component);
_defineProperty(TextInput, "propTypes", {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  defaultValue: PropTypes.string
});
_defineProperty(TextInput, "defaultProps", {
  disabled: false,
  onChange: _noop,
  placeholder: 'Type Here',
  style: {},
  defaultValue: ''
});
_defineProperty(TextInput, "Option", Option);
export default TextInput;